// extracted by mini-css-extract-plugin
module.exports = {"mainHomeContainer":"Home_mainHomeContainer__2HASB","center":"Home_center__2Dzaq","thumbnail":"Home_thumbnail__7E8S9"};